import { useTranslation } from "react-i18next";

type CapacityLegendProps = {
  view: "immediate" | "average";
  maxCapacity: number;
};

export function CapacityLegend({ view, maxCapacity }: CapacityLegendProps) {
  const { t, i18n } = useTranslation();
  const isVisible = Number.isFinite(Number(maxCapacity)) && Number(maxCapacity) > 0;
  
  const formatNumber = (num: number) => {
    return new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
  };
  
  if (!isVisible) return null;

  return (
    <section className="capacitybvroute__barnumber--container">
      <strong className="capacitybvroute__barnumber--title">
        {t(view === "average" ? "mapLegend.averageStocking" : "mapLegend.instantStocking")}
      </strong>
      <div className="capacitybvroute__barnumber--bar" />
      <div className="capacitybvroute__barnumber--containerlegend">
        {view === "average" ? (
          <>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(value => <span key={value}>{formatNumber(value)}</span>)}
          </>
        ) : (
          <>
            <span>{formatNumber(0)}</span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span>{formatNumber(Number(maxCapacity))}</span>
          </>
        )}
      </div>
    </section>
  );
}
